import React from 'react';
import './text.css'
const Text = (props) => {
    return ( <>
        <p className={props.x}>
        {props.text}
    </p>
    </> );
}
 
export default Text;